module.exports = __webpack_public_path__ + "media/images/icon_photo_plus_20-20-60e9af79962c918d34fd11dfeec99eb1.png";